module.exports = __webpack_public_path__ + "img/INTERIOR-ERTIGA-2.9bc390c5.jpg";